import { useTranslation } from 'react-i18next';
import { Paragraph, Headings } from '@sentara-health/optimahealth_web';

function UsernameInfoOverlay() {
  const { t } = useTranslation();
  return (
    <>
      <Headings
        level={5}
        text={t('activation.userNameTooltipText')}
        variant="bold"
        data-testid="userNameInfoOverlayHeader"
        className="mb-4"
      />
      <div className="row my-2">
        <div className="col-12">
          <Paragraph
            text=
            {t('activation.userNameRequirementsOne')}
            variant="regular"
            className="discList lh-1"
            data-testid="userNameInfoOverlayTextOne"
          />
          <Paragraph
            text={t('activation.userNameRequirementsTwo')}
            variant="regular"
            className="discList lh-1"
            data-testid="userNameInfoOverlayTextTwo"
          />
          <Paragraph
            text={t('activation.userNameRequirementsThree')}
            variant="regular"
            className="discList lh-1"
            data-testid="userNameInfoOverlayTextThree"
          />
          <Paragraph
            text={t('activation.userNameRequirementsFour')}
            variant="regular"
            className="discList lh-1"
            data-testid="userNameInfoOverlayTextFour"
          />
          <Paragraph
            text={t('activation.userNameRequirementsFive')}
            variant="regular"
            className="discList lh-1"
            data-testid="userNameInfoOverlayTextFive"
          />
        </div>
      </div>
      <Paragraph text={t('activation.userNameRequirementsSix')} variant="regular" data-testid="userNameInfoOverlayTextSix"/>
    </>
  );
}

export default UsernameInfoOverlay;
